import React from "react";
import Wrapper from "../layout/Wrapper";
import BannerComp from "../components/BannerComp/BannerComp";
import assests from "../ui/assests";
import CommonHeading from "../components/CommonHeading/CommonHeading";
import OurServicesComp from "../components/OurServicesComp/OurServicesComp";
import TestimonialsComp from "../components/TestimonialsComp/TestimonialsComp";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";
import FAQSec from "../components/FAQSec/FAQSec";
import ClientsWEWork from "../components/ServiceComponents/ClientsWEWork";

export default function Service() {
  return (
    <Wrapper>
      <BannerComp
        className="service_banner"
        image={assests.serviceBanner}
        title="Solutions That Build and Grow Your Online Presence"
        description="We are a web design and development company offering expert SEO, digital marketing, and complete web solutions tailored to your business needs."
      />
      <div className="cmn_gap">
        <div className="container">
          <CommonHeading
            className="services_offer_heading"
            isPrimary
            title="What We Offer"
            paratext="We provide a full range of web services—from design and development to SEO and digital marketing—focused on helping businesses succeed online. Our approach is client-first, results-driven, and built around delivering excellence."
          />
        </div>
      </div>
      <OurServicesComp />
      <ClientsWEWork />
      <TestimonialsComp />
      <FAQSec />
      <DesignFutureSec />
    </Wrapper>
  );
}
